(function () {
  if (window.aanvulrijGeladen) return;
  window.aanvulrijGeladen = true;

  var TEKST = {
    toevoegen: 'Hinzufügen',
    bezig: 'Bitte warten',
    op: 'Ausverkauft',
    optieOp: ' (ausverkauft)',
    kiesEerst: function (naam) { return 'Bitte wählen Sie zuerst eine ' + naam + '.'; },
    combinatieOp: 'Diese Kombination ist ausverkauft. Bitte wählen Sie eine andere.',
    mislukt: 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.'
  };

  function rij(kaart) {
    return kaart.closest('[data-av-rij]');
  }

  function varianten(kaart) {
    if (!kaart._av) {
      try {
        kaart._av = JSON.parse(kaart.querySelector('[data-av-varianten]').textContent);
      } catch (e) {
        kaart._av = [];
      }
    }
    return kaart._av;
  }

  function opties(kaart) {
    return Array.prototype.slice.call(kaart.querySelectorAll('[data-av-optie]'));
  }

  function waarde(el) {
    return el.tagName === 'SELECT' ? el.value : el.getAttribute('data-waarde');
  }

  function gekozen(kaart) {
    var uit = [];
    opties(kaart).forEach(function (el) {
      uit[+el.getAttribute('data-av-optie')] = waarde(el);
    });
    return uit;
  }

  function past(v, keuze, behalve) {
    for (var i = 0; i < keuze.length; i++) {
      if (i === behalve || !keuze[i]) continue;
      if (v.o[i] !== keuze[i]) return false;
    }
    return true;
  }

  function variant(kaart) {
    var keuze = gekozen(kaart);
    for (var i = 0; i < keuze.length; i++) {
      if (keuze[i] === '' || keuze[i] == null) return null;
    }
    var lijst = varianten(kaart);
    for (var j = 0; j < lijst.length; j++) {
      if (past(lijst[j], keuze, -1)) return lijst[j];
    }
    return null;
  }

  function geld(centen, formaat) {
    var bedrag = (centen / 100).toFixed(2);
    var komma = bedrag.replace('.', ',');
    formaat = formaat || '{{amount_with_comma_separator}} €';
    return formaat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, soort) {
      if (soort === 'amount') return bedrag;
      if (soort.indexOf('no_decimals') > -1) return String(Math.round(centen / 100));
      return komma;
    });
  }

  function meld(kaart, tekst) {
    var m = kaart.querySelector('[data-av-melding]');
    if (!m) return;
    m.textContent = tekst || '';
    m.hidden = !tekst;
  }

  function werkBij(kaart) {
    var lijst = varianten(kaart);
    var keuze = gekozen(kaart);

    opties(kaart).forEach(function (el) {
      if (el.tagName !== 'SELECT') return;
      var plek = +el.getAttribute('data-av-optie');
      Array.prototype.forEach.call(el.options, function (opt) {
        if (!opt.value) return;
        if (!opt.hasAttribute('data-av-naam')) opt.setAttribute('data-av-naam', opt.textContent);
        var kan = lijst.some(function (v) {
          return v.a && v.o[plek] === opt.value && past(v, keuze, plek);
        });
        opt.disabled = !kan;
        opt.textContent = opt.getAttribute('data-av-naam') + (kan ? '' : TEKST.optieOp);
      });
    });

    var v = variant(kaart);
    var knop = kaart.querySelector('[data-av-toevoegen]');
    var r = rij(kaart);
    var gat = r ? +r.getAttribute('data-gat') : 0;
    var formaat = r ? r.getAttribute('data-geld') : '';

    if (v) {
      var prijs = kaart.querySelector('[data-av-prijs]');
      if (prijs) prijs.textContent = geld(v.p, formaat);
      var label = kaart.querySelector('[data-av-label]');
      if (label) label.hidden = v.p < gat;
      var foto = kaart.querySelector('[data-av-foto]');
      if (foto && v.f && foto.getAttribute('src') !== v.f) foto.setAttribute('src', v.f);
    }

    if (knop) {
      var op = v && !v.a;
      knop.disabled = !!op;
      knop.textContent = op ? TEKST.op : TEKST.toevoegen;
    }
    kaart._avKlaar = true;
  }

  function alles() {
    document.querySelectorAll('[data-av-kaart]').forEach(function (kaart) {
      if (!kaart._avKlaar) werkBij(kaart);
    });
  }

  function markeerLeeg(kaart) {
    var eerste = null;
    opties(kaart).forEach(function (el) {
      var leeg = el.tagName === 'SELECT' && !el.value;
      el.classList.toggle('is-fout', leeg);
      if (leeg && !eerste) eerste = el;
    });
    return eerste;
  }

  function scroller() {
    return document.querySelector('#CartDrawer [data-hdt-scroll-me]');
  }

  function naRender(stand, handle) {
    var s = scroller();
    if (s) s.scrollTop = document.querySelector('#CartDrawer [data-av-rij]') ? stand : 0;
    if (!handle) return;
    var link = document.querySelector('#CartDrawer .hdt-mini-cart__title[href*="/products/' + handle + '?"]') ||
      document.querySelector('#CartDrawer .hdt-mini-cart__title[href$="/products/' + handle + '"]');
    var regel = link && link.closest('.hdt-mini-cart__item');
    if (regel) {
      regel.classList.add('av-nieuw');
      setTimeout(function () { regel.classList.remove('av-nieuw'); }, 1900);
    }
  }

  function voegToe(kaart, knop) {
    var leeg = markeerLeeg(kaart);
    if (leeg) {
      meld(kaart, TEKST.kiesEerst(leeg.getAttribute('aria-label') || 'Größe'));
      leeg.focus();
      return;
    }
    var v = variant(kaart);
    if (!v || !v.a) {
      meld(kaart, TEKST.combinatieOp);
      return;
    }
    meld(kaart, '');
    knop.classList.add('is-bezig');
    knop.textContent = TEKST.bezig;

    var titel = kaart.querySelector('.av-kaart__titel');
    var handle = titel ? (titel.getAttribute('href') || '').split('/products/')[1] : '';
    handle = handle ? handle.split(/[?#]/)[0] : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var secties = [];
    document.dispatchEvent(new CustomEvent('cart:push:section.id', { bubbles: true, detail: { sections: secties } }));
    var s = scroller();
    var stand = s ? s.scrollTop : 0;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: v.id, quantity: 1, properties: { _aanvulrij: 'ja' } }],
        sections: secties.join(',')
      })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      })
      .then(function (uit) {
        if (!uit.ok || uit.d.status) {
          knop.classList.remove('is-bezig');
          knop.textContent = TEKST.toevoegen;
          meld(kaart, uit.d.description || uit.d.message || TEKST.mislukt);
          return;
        }
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (wagen) {
            wagen.sections = uit.d.sections || {};
            document.addEventListener('cart:drawer:render', function eenmalig() {
              document.removeEventListener('cart:drawer:render', eenmalig);
              naRender(stand, handle);
            });
            document.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'aanvulrij', cart: wagen, items: uit.d.items || [] }
            }));
          });
      })
      .catch(function () {
        knop.classList.remove('is-bezig');
        knop.textContent = TEKST.toevoegen;
        meld(kaart, TEKST.mislukt);
      });
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-av-kaart] select[data-av-optie]')) return;
    var kaart = el.closest('[data-av-kaart]');
    el.classList.remove('is-fout');
    meld(kaart, '');
    werkBij(kaart);
  });

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-av-toevoegen]');
    if (!knop) return;
    e.preventDefault();
    voegToe(knop.closest('[data-av-kaart]'), knop);
  });

  document.addEventListener('cart:drawer:render', alles);

  function kijk() {
    var paneel = document.getElementById('CartDrawer');
    if (paneel && !paneel._avKijkt) {
      paneel._avKijkt = true;
      new MutationObserver(alles).observe(paneel, { childList: true, subtree: true });
    }
    alles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kijk);
  } else {
    kijk();
  }
})();
